import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { User } from 'projects/core/src/lib/login/data/user';
import { LocalStorage } from 'ngx-webstorage';
import { UserService } from 'projects/core/src/lib/login/data/user.service';
import { KanbanBoardStore } from '../../../data/kanban-board.store';
import { ProjectStatus } from 'projects/app-misc/src/app/modules/project-misc/data/project/statuses/project-status';
import { ProjectService } from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import { MultiSelect } from 'primeng/multiselect';

@Component({
    selector: 'app-payment-status-filter',
    templateUrl: './payment-status-filter.component.html',
    styleUrls: ['./payment-status-filter.component.scss']
})
export class PaymentStatusFilterComponent implements OnInit {
    selectedStatus: ProjectStatus[] = [];

    @Output()
    changeDetect = new EventEmitter<any>();

    pStatuses: ProjectStatus[]

    @LocalStorage()
    filteredStatuses: number[];

    statusFiltersLabel: string;

    @Output()
    filterOn = new EventEmitter<boolean>();

    @ViewChild('multiSelect', { static: true })
    multiSelect: MultiSelect

    constructor(
        protected projectService: ProjectService,
        protected kanbanBoardStore: KanbanBoardStore
    ) {

    }

    ngOnInit(): void {

        this.projectService.getPaymentStatuses().subscribe(pStatuses => {
            this.pStatuses = pStatuses
            let selectedUsersIds: number[]

            if (!this.filteredStatuses) {
                this.selectedStatus = pStatuses
                selectedUsersIds = this.pStatuses.map(status => status.id);
            }
            else {
                const uIds = this.pStatuses.map(user => user.id)
                const fUIds = this.filteredStatuses;
                const colsMap = new Map(this.pStatuses.map(col => [col.id, col]));

                selectedUsersIds = uIds.filter(x => !fUIds.includes(x));
                this.selectedStatus = selectedUsersIds.map(id => colsMap.get(id));
            }

            this.filteredStatuses = this.pStatuses.map(cols => cols.id).filter(colId => !selectedUsersIds.includes(colId));

            this.kanbanBoardStore.updatePaymentStatusesFilter(this.filteredStatuses.length > 0 ? selectedUsersIds : undefined);

            this.countFilter();
        })
    }

    updateStatuses() {
        const selectedUsersIds = this.selectedStatus.map(col => col.id)

        this.filteredStatuses = this.pStatuses.map(cols => cols.id).filter(colId => !selectedUsersIds.includes(colId));

        this.kanbanBoardStore.updatePaymentStatusesFilter(this.filteredStatuses.length > 0 ? selectedUsersIds : undefined);

        this.countFilter();
    }

    countFilter() {
        this.statusFiltersLabel = this.selectedStatus.length + ' statuses selected';

        if (this.selectedStatus.length === this.pStatuses.length) {
            this.statusFiltersLabel = 'Filter Statuses';

            this.filterOn.emit(false);
        }
        else {
            this.filterOn.emit(true);
        }
    }

    showAll() {
        this.multiSelect.toggleAll({})
    }

}
